import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserOperatorModel } from '../_models/user-operator-model';
import { AuthenticationService } from '../_services/authentication.service';
import { UserAccountService } from '../_services/user-account.service';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent {
  isExpanded = false;

  userOperators: Array<UserOperatorModel> = new Array<UserOperatorModel>();

  constructor(public authenticationService: AuthenticationService, public userAccountService: UserAccountService, private _router: Router) {

    this.authenticationService.currentUserSubject.subscribe((newUserModel) => {

      this.userOperators = new Array<UserOperatorModel>();

      if (newUserModel != null) {
        this.userAccountService.fetchOperatorsForUser(newUserModel.Id).then((operatorJunctions) => {
          this.userOperators = operatorJunctions;
        },
        (err) => {
          this.userOperators = new Array<UserOperatorModel>();
        });
      }
    });

  }

  isUserAnApprover() {

    var approverJunctions = this.userOperators.find((element) => {
      return element.IsApprover;
    });

    return (approverJunctions != null);
  }

  isUserAnAdmin() {
    var ret = false;

    if (this.authenticationService.currentUserSubject.value != null) {
      var user = this.authenticationService.currentUserSubject.value;

      if (user.Role == "Admin") {
        ret = true;
      }
    }

    return ret;
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  logout() {
    this.authenticationService.logout();
    this._router.navigateByUrl('/login');
  }
}
